import { render, staticRenderFns } from "./game-create.vue?vue&type=template&id=2e991972&scoped=true"
import script from "./game-create.vue?vue&type=script&lang=ts"
export * from "./game-create.vue?vue&type=script&lang=ts"
import style0 from "./game-create.vue?vue&type=style&index=0&id=2e991972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e991972",
  null
  
)

export default component.exports